var $ = require( "jquery" )

$(document).ready( function(){
  var $form = $('[data-service-report-form]');
  if( !$form.length ){ return; }

  var config = $form.data('field-config');
  if( !config ){ return; }

  var GG_NATIONAL_CATEGORY = 'GG National Programming';
  var $eventSelect = $form.find('#service_report_event_id');
  var $selectAll = $form.find('[data-sr-select-all]');
  var volunteerSelector = 'input[name="service_report[volunteer_ids][]"]';

  // An event type's own list wins; a category with a report of its own asks for
  // nothing extra, which is how the six GG National Programming types share one
  // report; anything else is still on the original list.
  function tailoredFields( eventType, category ){
    var tailored = config.tailored || {};
    if( tailored.hasOwnProperty( eventType ) ){ return tailored[eventType]; }

    var categories = config.tailored_categories || [];
    if( category && categories.indexOf( category ) !== -1 ){ return []; }

    return config.legacy;
  }

  // Photos sit on every report except GG National Programming, so a form can
  // drop a common field as well as add its own.
  function commonFields( category ){
    var excluded = (config.excluded_common || {})[category] || [];

    return config.common.filter( function( field ){
      return excluded.indexOf( field ) === -1;
    });
  }

  function fieldsForEventType( eventType, category ){
    if( !eventType ){ return config.common; }

    return commonFields( category ).concat( tailoredFields( eventType, category ) );
  }

  function answerFor( field ){
    var $input = $form.find('#service_report_' + field);
    if( !$input.length ){ return null; }

    var value = $input.val();
    if( value === 'true' ){ return true; }
    if( value === 'false' ){ return false; }

    return value;
  }

  function conditionMet( condition ){
    if( !condition ){ return true; }

    var answer = answerFor( condition.on );

    if( condition.present ){ return !!answer; }

    return answer === condition.equals;
  }

  function applyConditionals(){
    var conditional = config.conditional || {};
    var sections = config.static_sections || {};

    $.each( conditional, function( field, condition ){
      var $row = $form.find('[data-sr-field="' + field + '"]');
      if( !$row.length || !$row.data('sr-asked') ){ return; }

      $row.toggle( conditionMet( condition ) );
    });

    $.each( sections, function( section, condition ){
      $form.find('[data-sr-section="' + section + '"]').toggle( conditionMet( condition ) );
    });
  }

  function applyLabels( eventType ){
    var overrides = (config.labels || {})[eventType] || {};

    $form.find('[data-sr-field] label[for]').each( function(){
      var $label = $(this);
      var field = String( $label.attr('for') ).replace(/^service_report_/, '');

      if( $label.data('default-label') === undefined ){ $label.data('default-label', $label.text()); }

      $label.text( overrides[field] || $label.data('default-label') );
    });
  }

  function applyRequiredMarkers( eventType ){
    var required = config.required || {};
    var declared = {};

    $.each( required, function( _type, fields ){
      $.each( fields, function( _i, field ){ declared[field] = true; });
    });

    var here = required[eventType] || [];

    $form.find('[data-sr-field] label[for]').each( function(){
      var $label = $(this);
      var field = String( $label.attr('for') ).replace(/^service_report_/, '');
      if( !declared[field] ){ return; }

      $label.toggleClass('required', here.indexOf( field ) !== -1 );
    });
  }

  // The volunteers a report may tick depend on the event: a GG National
  // Programming report reaches across every chapter. That list is server-rendered,
  // so ask for it again rather than reloading the whole form.
  var $volunteers = $form.find('[data-sr-volunteers]');
  var volunteersUrl = $volunteers.data('sr-volunteers-url');
  var lastVolunteersEventId = $eventSelect.val();

  function refreshVolunteers(){
    if( !$volunteers.length || !volunteersUrl ){ return; }

    var eventId = $eventSelect.val();
    if( eventId === lastVolunteersEventId ){ return; }

    lastVolunteersEventId = eventId;

    var checked = $volunteers.find('input:checked').map( function(){
      return $(this).val();
    }).get();

    $.get( volunteersUrl, { event_id: eventId } )
      .done( function( html ){
        $volunteers.html( html );

        // Keep anyone already ticked who is still on the new list.
        $.each( checked, function( _i, id ){
          $volunteers.find('input[value="' + id + '"]').prop('checked', true);
        });

        refreshChosenEmptyState();
        refreshSelectAllState();
      });
  }

  var searchTimer = null;
  var emptyChapterId = null;

  function chapterFilterId(){
    return $form.find('[data-sr-chapter-id]').val() || '';
  }

  function pickerInputs(){
    return $form.find('[data-sr-combobox-input], [data-sr-volunteer-search]');
  }

  function listFor( $input ){
    return $input.closest('[data-sr-combobox]')
      .find('[data-sr-combobox-options], [data-sr-volunteer-results]').first();
  }

  function optionsIn( $list ){
    return $list.find('[data-sr-chapter-option], [data-sr-volunteer-option]').filter(':visible');
  }

  function clearHighlight( $list ){
    $list.find('.is-active').removeClass('is-active').attr('aria-selected', 'false');
  }

  function openList( $input ){
    var $list = listFor( $input );
    $list.show();
    $input.attr('aria-expanded', 'true');

    return $list;
  }

  function closeList( $input ){
    clearHighlight( listFor( $input ).hide() );
    $input.attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
  }

  function closeOptions(){
    pickerInputs().each( function(){ closeList( $(this) ); });
  }

  function highlight( $input, $option ){
    clearHighlight( listFor( $input ) );

    if( !$option || !$option.length ){
      $input.removeAttr('aria-activedescendant');
      return;
    }

    $option.addClass('is-active').attr('aria-selected', 'true');
    $input.attr('aria-activedescendant', $option.attr('id') || '');

    if( $option.get(0).scrollIntoView ){ $option.get(0).scrollIntoView({ block: 'nearest' }); }
  }

  function moveHighlight( $input, step ){
    var $options = optionsIn( openList( $input ) );
    if( !$options.length ){ return; }

    var index = $options.index( listFor( $input ).find('.is-active') );
    index = index < 0 ? (step > 0 ? 0 : $options.length - 1)
                      : (index + step + $options.length) % $options.length;

    highlight( $input, $options.eq( index ) );
  }

  function chooseHighlighted( $input ){
    var $option = listFor( $input ).find('.is-active').first();
    if( !$option.length ){ return; }

    $option.trigger('click');
  }

  function chosenIds(){
    return $form.find('[data-sr-chosen-volunteer]').map( function(){
      return String( $(this).data('sr-chosen-volunteer') );
    }).get();
  }

  function refreshChosenEmptyState(){
    var any = $form.find('[data-sr-chosen-volunteer]').length > 0;

    $form.find('[data-sr-no-volunteers-chosen]').toggle( !any );
  }

  function addVolunteer( $option ){
    var id = String( $option.data('sr-volunteer-id') );
    if( chosenIds().indexOf( id ) !== -1 ){ return; }

    var name = $option.data('sr-volunteer-name');
    var chapter = $option.data('sr-volunteer-chapter') || '';

    var $row = $('<li>')
      .addClass('sr-volunteer-pill')
      .attr('data-sr-chosen-volunteer', id);

    $('<input>').attr({ type: 'hidden', name: 'service_report[volunteer_ids][]', value: id }).appendTo( $row );
    $('<span>').text( name ).appendTo( $row );
    $('<span>').addClass('sr-volunteer-pill__chapter').text( chapter ).appendTo( $row );

    $('<button>')
      .addClass('sr-volunteer-pill__remove')
      .attr({ type: 'button', 'aria-label': 'Remove ' + name, 'data-sr-remove-volunteer': true, 'data-skip-disable': 'true' })
      .text('×')
      .appendTo( $row );

    $form.find('[data-sr-chosen-volunteers]').append( $row );
    refreshChosenEmptyState();
  }

  function cancelSearch(){
    window.clearTimeout( searchTimer );
  }

  function scheduleSearch(){
    cancelSearch();
    searchTimer = window.setTimeout( searchVolunteers, 200 );
  }

  function searchNow(){
    cancelSearch();
    searchVolunteers();
  }

  function searchVolunteers(){
    var $input = $form.find('[data-sr-volunteer-search]');
    if( !$input.length ){ return; }

    var $results = openList( $input );
    var chapterId = chapterFilterId();
    if( chapterId && chapterId === emptyChapterId ){ return; }

    $.get( $input.data('sr-volunteer-search-url'), {
      q: $.trim( $input.val() ),
      event_id: $eventSelect.val() || $input.data('sr-event-id'),
      volunteer_chapter_id: chapterId,
      exclude: chosenIds().join(',')
    }).done( function( html ){
      $results.html( html );
      openList( $input );
      $input.removeAttr('aria-activedescendant');

      emptyChapterId = $results.find('[data-sr-chapter-empty]').length ? chapterId : null;
    });
  }

  function applySelectAllVisibility(){
    var category = $eventSelect.find('option:selected').data('event-category');

    $form.find('[data-sr-select-all-row]').toggle( category !== GG_NATIONAL_CATEGORY );
  }

  function refreshSelectAllState(){
    var $boxes = $form.find( volunteerSelector ).filter(':visible');
    if( !$boxes.length || !$selectAll.length ){ return; }

    var checked = $boxes.filter(':checked').length;

    $selectAll.prop('checked', checked === $boxes.length );
    $selectAll.prop('indeterminate', checked > 0 && checked < $boxes.length );
  }

  function applyEventType(){
    var $selected = $eventSelect.find('option:selected');
    var eventType = $selected.data('event-type');
    var category = $selected.data('event-category');
    var visible = fieldsForEventType( eventType, category );

    $form.find('[data-sr-hint]').toggle( !eventType );

    $form.find('[data-sr-field]').each( function(){
      var field = String( $(this).data('sr-field') );
      var asked = visible.indexOf( field ) !== -1;

      $(this).data('sr-asked', asked ).toggle( asked );
    });

    applyLabels( eventType );
    applyRequiredMarkers( eventType );
    applyConditionals();
    applySelectAllVisibility();
  }

  $eventSelect.change( function(){
    applyEventType();
    refreshVolunteers();
  });

  function conditionParentSelector(){
    var fields = {};

    $.each( [config.conditional || {}, config.static_sections || {}], function( _i, rules ){
      $.each( rules, function( _key, condition ){ fields['#service_report_' + condition.on] = true; });
    });

    return Object.keys( fields ).join(', ');
  }

  var parentSelector = conditionParentSelector();
  if( parentSelector ){ $form.on('change', parentSelector, applyConditionals ); }

  $selectAll.change( function(){
    $form.find( volunteerSelector ).filter(':visible').prop('checked', $(this).is(':checked') );
    refreshSelectAllState();
  });

  $form.on('change', volunteerSelector, refreshSelectAllState );

  $form.on('keydown', '[data-sr-combobox-input], [data-sr-volunteer-search]', function( event ){
    var $input = $(this);

    if( event.key === 'ArrowDown' || event.key === 'ArrowUp' ){
      event.preventDefault();
      moveHighlight( $input, event.key === 'ArrowDown' ? 1 : -1 );
    }
    else if( event.key === 'Enter' ){
      event.preventDefault();
      chooseHighlighted( $input );
    }
    else if( event.key === 'Escape' || event.key === 'Tab' ){
      closeList( $input );
    }
  });

  $form.on('focus click', '[data-sr-combobox="chapter"] [data-sr-combobox-input]', function(){
    openList( $(this) );
  });

  $form.on('input', '[data-sr-combobox="chapter"] [data-sr-combobox-input]', function(){
    var $input = $(this);
    var term = $.trim( $input.val() ).toLowerCase();
    var $chapterId = $input.closest('[data-sr-combobox]').find('[data-sr-chapter-id]');
    var chosenId = $chapterId.val();

    var matchedId = '';

    openList( $input ).find('[data-sr-chapter-option]').each( function(){
      var name = String( $(this).data('sr-chapter-name') || '' ).toLowerCase();
      var id = String( $(this).data('sr-chapter-option') || '' );

      if( id && term && name === term ){ matchedId = id; }

      $(this).toggle( !term || name.indexOf( term ) !== -1 );
    });

    highlight( $input, null );
    $chapterId.val( matchedId );

    if( matchedId !== chosenId ){ scheduleSearch(); }
  });

  $form.on('click', '[data-sr-chapter-option]', function(){
    var $option = $(this);
    var id = String( $option.data('sr-chapter-option') || '' );
    var name = $option.data('sr-chapter-name');
    var $box = $option.closest('[data-sr-combobox]');
    var $input = $box.find('[data-sr-combobox-input]');

    $box.find('[data-sr-chapter-id]').val( id );
    $input.val( id ? name : '' );
    closeList( $input );

    searchNow();
  });

  $form.on('input', '[data-sr-volunteer-search]', scheduleSearch );

  $form.on('focus click', '[data-sr-volunteer-search]', scheduleSearch );

  $form.on('click', '[data-sr-volunteer-option]', function(){
    var $input = $form.find('[data-sr-volunteer-search]');

    addVolunteer( $(this) );

    $input.val('').focus();
    cancelSearch();
    closeList( $input );
  });

  $form.on('click', '[data-sr-remove-volunteer]', function(){
    $(this).closest('[data-sr-chosen-volunteer]').remove();
    refreshChosenEmptyState();

    if( $form.find('[data-sr-volunteer-results]').is(':visible') ){ searchNow(); }
  });

  $(document).on('click', function( event ){
    if( !$(event.target).closest('[data-sr-combobox]').length ){ closeOptions(); }
  });

  applyEventType();
  refreshSelectAllState();
});
